module.exports = __webpack_public_path__ + "static/laura_0-e8fcf69edf2ab19aace5eeebc755ee85.jpg";